import { memo } from "react";
import PinnedIcon from "@/common/images/icons/pinned.svg?react";
import PinnedFilledIcon from "./images/icons/pinnedFilled.svg?react";
import "./PinButton.scss";

interface IPinButton {
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  pinned?: boolean;
}

export const PinButton: React.FC<IPinButton> = memo(({
  className,
  onClick,
  pinned = false
}) => {
  return (
    <button
      className={`PinButton ${className}`}
      onClick={onClick}
      aria-label="pin button"
    >
      {pinned ? <PinnedFilledIcon /> : <PinnedIcon />}
    </button>
  );
});
